export default __webpack_public_path__ + "static/media/cta-bg.00700598.jpg";